/**
 * Initialen-Avatar (34px Kreis), wie `.avatar` im Design-Canvas-Artefakt
 * "ShiftSync Rollenansichten". Ursprünglich lokal in DashboardPage.tsx,
 * ausgelagert (Nachtrag Standort-Detail-Ansicht, 08.09.2026) — dieselbe
 * Komponente wird jetzt auch auf der neuen Standort-Detail-Seite gebraucht.
 *
 * `manager=true` färbt den Avatar blau (wie die Filialleitung-Zeile in
 * StandortDetail.dc.html), sonst neutrales Grau (wie alle übrigen Zeilen
 * in Main.dc.html/Filialleitung.dc.html).
 */

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '?';
  if (parts.length === 1) return first.slice(0, 2).toUpperCase();
  const last = parts[parts.length - 1] ?? first;
  return ((first[0] ?? '') + (last[0] ?? '')).toUpperCase();
}

export function Avatar({ name, manager }: { name: string; manager?: boolean }) {
  return (
    <div
      className={`w-[34px] h-[34px] rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 ${
        manager ? 'bg-blue-500/20 text-blue-300' : 'bg-slate-500/25 text-slate-200'
      }`}
      aria-hidden
    >
      {initials(name)}
    </div>
  );
}
